import { Shortcut } from 'src/constants/appShortcuts';
import { create } from 'zustand';

export type StoreShortcut = Shortcut & {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  callback: (...args: any[]) => void;
};

interface ShortcutsState {
  shortcuts: Map<string, StoreShortcut[]>;
  addShortcut: (shortcut: StoreShortcut) => void;
  removeShortcut: (shortcut: StoreShortcut) => void;
  getShortcutForCommand: (command: string) => StoreShortcut | null;
  getAllShortcuts: () => ShortcutsState['shortcuts'];
}

export const useShortcutsStore = create<ShortcutsState>((set, get) => ({
  shortcuts: new Map(),
  addShortcut: (shortcut: StoreShortcut) => {
    const currentShortcuts = [...(get().shortcuts.get(shortcut.command) || [])];
    currentShortcuts.push(shortcut);
    set({
      shortcuts: new Map(get().shortcuts).set(shortcut.command, currentShortcuts),
    });
  },
  removeShortcut: (shortcut: StoreShortcut) => {
    const currentShortcuts = get().shortcuts.get(shortcut.command) || [];
    const updatedShortcuts = currentShortcuts.filter((s) => s !== shortcut);
    set({
      shortcuts: new Map(get().shortcuts).set(shortcut.command, updatedShortcuts),
    });
  },
  getShortcutForCommand: (command: string) => {
    const shortcuts = get().shortcuts.get(command);
    return shortcuts?.length ? shortcuts[shortcuts.length - 1] : null;
  },
  getAllShortcuts: () => get().shortcuts,
}));
